import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_ds_get_footprint_eventsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { status_ids: number[], from_date: string, type_ids?: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, EndProcessingDate?: string, ErrorMessage?: string, Label?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Notes?: string, PublishedDate?: string, StartProcessingDate?: string, StatusId?: number, TypeId?: number, FootPrintEventDetails?: { FieldName?: string, FieldValue?: string, IntFieldValue?: number, XmlFieldValue?: string }[], FootPrintEventStatus?: { Name?: string }, FootPrintEventType?: { Name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.status_ids)) {
      $missingRequiredInParams.push('\'status_ids\'');
    }
    if (isNil($inParams.from_date)) {
      $missingRequiredInParams.push('\'from_date\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { status_ids: number[], from_date: string, type_ids?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, EndProcessingDate?: string, ErrorMessage?: string, Label?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Notes?: string, PublishedDate?: string, StartProcessingDate?: string, StatusId?: number, TypeId?: number, FootPrintEventDetails?: { FieldName?: string, FieldValue?: string, IntFieldValue?: number, XmlFieldValue?: string }[], FootPrintEventStatus?: { Name?: string }, FootPrintEventType?: { Name?: string } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.status_ids)) {
      $missingRequiredInParams.push('\'status_ids\'');
    }
    if (isNil($inParams.from_date)) {
      $missingRequiredInParams.push('\'from_date\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { status_ids: number[], from_date: string, type_ids?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, EndProcessingDate?: string, ErrorMessage?: string, Label?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Notes?: string, PublishedDate?: string, StartProcessingDate?: string, StatusId?: number, TypeId?: number, FootPrintEventDetails?: { FieldName?: string, FieldValue?: string, IntFieldValue?: number, XmlFieldValue?: string }[], FootPrintEventStatus?: { Name?: string }, FootPrintEventType?: { Name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.status_ids)) {
      $missingRequiredInParams.push('\'status_ids\'');
    }
    if (isNil($inParams.from_date)) {
      $missingRequiredInParams.push('\'from_date\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      status_ids: number[], from_date: string, type_ids?: number[]    }) {
        if(isNil($inParams.status_ids)) {
          return true; 
        }
        if(isNil($inParams.from_date)) {
          return true; 
        }
      return false;
    }
}
